import { IconType } from 'react-icons/lib';

const JobAcceptedIcon: React.FC<{ color?: string; height?: number; width?: number }> = ({
  color,
  height = 24,
  width = 24,
}) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 33 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle cx="16.5" cy="16" r="16" fill="#00B4D8" />
    <g clipPath="url(#clip0_1003_26783)">
      <path
        d="M11.7 12.4008C11.7 11.446 12.0793 10.5303 12.7544 9.8552C13.4295 9.18007 14.3452 8.80078 15.3 8.80078C16.2548 8.80078 17.1705 9.18007 17.8456 9.8552C18.5207 10.5303 18.9 11.446 18.9 12.4008C18.9 13.3556 18.5207 14.2712 17.8456 14.9464C17.1705 15.6215 16.2548 16.0008 15.3 16.0008C14.3452 16.0008 13.4295 15.6215 12.7544 14.9464C12.0793 14.2712 11.7 13.3556 11.7 12.4008ZM9 22.3655C9 19.5952 11.2444 17.3508 14.0147 17.3508H16.5853C19.3556 17.3508 21.6 19.5952 21.6 22.3655C21.6 22.8267 21.2259 23.2008 20.7647 23.2008H9.83531C9.37406 23.2008 9 22.8267 9 22.3655ZM26.5781 13.7789L22.9781 17.3789C22.7137 17.6433 22.2863 17.6433 22.0247 17.3789L20.2247 15.5789C19.9603 15.3145 19.9603 14.887 20.2247 14.6255C20.4891 14.3639 20.9166 14.3611 21.1781 14.6255L22.5 15.9473L25.6219 12.8227C25.8862 12.5583 26.3137 12.5583 26.5753 12.8227C26.8369 13.087 26.8397 13.5145 26.5753 13.7761L26.5781 13.7789Z"
        fill={color ?? 'white'}
      />
    </g>
    <defs>
      <clipPath id="clip0_1003_26783">
        <rect width="18" height="14.4" fill="white" transform="translate(9 8.80078)" />
      </clipPath>
    </defs>
  </svg>
);

const JobAcceptIcon: IconType = () => <JobAcceptedIcon color="currentColor" />;

export default JobAcceptedIcon;
export { JobAcceptIcon };
